import ActionDropdown from "../../ActionDropdown";
import TableCheck from "../TableCheck";
import { dateFine } from "../../../util/Utilities";
import DateFormatter from "../../DateFormatter";
import clsx from "clsx";

const PlansColumns = [
    {
        Label: TableCheck,
        Component: TableCheck

    },
    {
        Label: () => 'id',
        accessor: 'id'
    },
    {
        Label: () => 'Código Centro De Costo',
        Component: ({ value }) => value?.costCenter?.code || '--'
    },
    {
        Label: () => 'Centro de costo',
        Component: ({ value }) => `${value?.costCenter?.name || '--'}`
    },
    {
        Label: () => 'Año',
        Component: ({ value }) => `${value?.planningProcess?.forYear || '--'}`
    },
    {
        Label: () => 'Estatus',
        Component: ({ value }) => <div className={clsx(["btn btn-xs"], {
            'btn-success': value?.status === 'OPEN',
            'btn-danger': value?.status === 'CLOSED',
        })}>
            {value?.status === 'CLOSED' ?
                'Cerrado'
                :
                'Abierto'
            }
        </div>
    },
    {
        Label: () => 'Fecha de cierre',
        Component: ({ value }) => value?.closedAt ? <DateFormatter value={dateFine(value?.closedAt)} dateFormat="dd/MM/yyyy" /> : '--'
    },
    {
        Label: () => 'Aprobador',
        Component: ({ value }) => `${value?.approvedBy?.name || '--'}`
    },
    {
        Label: () => 'Fecha de aprobación',
        Component: ({ value }) => value?.approvedAt ? <DateFormatter value={dateFine(value?.approvedAt)} dateFormat="dd/MM/yyyy" /> : '--'
    },
    {
        Label: () => 'Fecha de Creación',
        Component: ({ value }) => <DateFormatter value={dateFine(value?.createdAt)} dateFormat="dd/MM/yyyy hh:mm:ss" />
    },
    {
        Label: () => 'Acciones',
        Component: ({ value, onDelete }) => <ActionDropdown withOutUpdate value={value} onDelete={onDelete} />
    }
];

export default PlansColumns;

